<div>
    <button [class.spinner-border]="status() === 'loading'" type="button" [disabled]="!accountantId()" class="bg-transparent border-0 bg-none fa-solid fa-rotate" (click)="fetchQrCodeLink()">
    </button>
</div>
